/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useLayoutEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import "./index.css";

// Redux Imports
import {
  internalTxnAccountDetail,
  internalTxnApproval,
  internalTxnDenied,
  internalTxnRequireApprovalPage,
  updateInternalDetailData,
} from "../../../redux/features/internalTransaction/internalTransactionDetailPage";
import {
  addInternalTxnLabel,
  removeInternalTxnLabel,
} from "../../../redux/features/InternalAccount/internalAccount";

import { disableSwitcher } from "../../../redux/features/multiEntitySwitcher/multiEntitySwitcher";

// Components Imports
import TEXT from "../../../../src/utils/globalText.js";
import CommonBankLogo from "../../../components/_utils/CommonBankLogo/index.jsx";
import Chips from "../../../components/_utils/CommonButtons/Chips/index.jsx";
import PositiveNegativeButton from "../../../components/_utils/CommonButtons/PositiveNegativeButton";
import PrimaryWithIconButton from "../../../components/_utils/CommonButtons/PrimaryWithIconButton";
import SwitcherTabs from "../../../components/_utils/CommonButtons/SwitcherTabs/index.jsx";
import TopNavLargeButton from "../../../components/_utils/CommonButtons/TopNavLargeButton";
import TopNavSmallButton from "../../../components/_utils/CommonButtons/TopNavSmallButton";
import CommonContainerCard from "../../../components/_utils/CommonContainerCard/index.jsx";
import CommonDetailCard from "../../../components/_utils/CommonDetailCard/index.jsx";
import CommonInfoBox from "../../../components/_utils/CommonInfoBox/index.jsx";
import CommonAssignLabelPopup from "../../../components/_utils/CommonPopups/CommonAssignLabelPopup";
import LargePopupRedirect from "../../../components/_utils/CommonPopups/CommonLargePopupRedirect";
import { formatAccountNumber } from "../../../components/_utils/FormatAccountNumber";
import RecreatePromptModalPopup from "../../../components/_utils/RecreatePromptModalPopup";
import { default as SvgComponent } from "../../../components/_utils/SVGComponent/index.jsx";
import TitleSubtitlePair from "../../../components/_utils/TitleSubtitlePair/index.jsx";
import InternalTxnDeclinePopup from "../../../components/_utils/TransactionCommonComponents/CommonDeclinePopups/InternalTxnDeclinePopup.jsx";
import InternalAccDetailsPopUp from "../../../components/Accounts/InternalAccDetailPopup";
import CommonTimeLineCard, {
  addLifeCycleStatus,
} from "../../../components/CommonTimeLineCard/index.jsx";
import FullScreen from "../../../components/FullScreen";
import Loader from "../../../components/Loader/Index";
import TimelinePopupContent from "../../../components/_utils/TimelinePopupContent/index.jsx";
import UniversalRefreshToast from "../../../components/_utils/UniversalRefreshToast/index.jsx";
import CommonToast from "../../../components/_utils/CommonToast/index.jsx";
import TimelineStatusBar from "../../../components/_utils/TimelineCommonComponents/TimelineStatusBar/index.jsx";
import InternalTransactionViewAll from "../InternalTransactionViewAll/index.jsx";
import accountNameStandardised from "../../../utils/accountNamestandardised.js";
import {
  errorcode,
  GlobalConfiguration,
  IntervalConfiguration,
  RejectReasonLength,
  TimelineBarConfiguration,
} from "../../../utils/configurationProvider.js";
import formatCurrency from "../../../utils/CurrencyFormater";
import formatDateViewAll from "../../../utils/formatDateViewAll";
import ISO_DataFormatter from "../../../utils/ISO_DataFormatter";
import OwnerAccountDetailsPopUp from "../../../components/Accounts/OwnerAccountDetailsPopUp/index.jsx";
import TopNavComponent from "../../../components/_utils/CommonTopNav/TopNavComponent/index.jsx";
import ICONS from "../../../assets/Icons/index.js";

const InternalTransactionDetails = ({
  internal_txn_id,
  closeInternalTxnDetailModal,
  type,
  error_msg,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const locationState = useLocation();
  const previousStatus = useLocation()?.state?.options?.state;
  const { id } = useParams();

  const cardRefs = useRef({});
  const cardRefsDist = useRef({});
  const leftContentRef = useRef(null);
  const labelActionDispatchedRef = useRef(false);

  const isPopup = type === "internal_txn_detail_modal";
  const [showRecreatePopup, setShowRecreatePopup] = useState(false);
  const [showDetails, setShowDetails] = useState(!isPopup);
  const [showAdditionalDetails, setShowAdditionalDetails] = useState(isPopup);
  const [showLabel, setShowLabel] = useState(false);
  const [alertPopUp, setAlertPopUp] = useState(false);
  const [infoBox, setInfoBox] = useState(false);
  const [viewInternalTxnDetails, setViewInternalTxnDetails] = useState();

  const [loading, setLoading] = useState(true);

  const [pages, setPages] = useState(GlobalConfiguration.lengthCheckZero);
  const [openTransHistory, setOpenTransHistory] = useState(false);

  const [loadingBox, setLoadingBox] = useState(false);
  const [internalTxnDetailID, setInternalTxnDetailID] = useState("");
  const [internalAccountID, setInternalAccountID] = useState("");
  const [showDeclineModal, setShowDeclineModal] = useState(false);
  const [showApprovalTimeline, setShowApprovalTimeline] = useState(false);
  const [showDistributionTimeline, setShowDistributionTimeline] =
    useState(false);
  const [networkError, setNetworkError] = useState(false);
  const [errorMessage, setErrorMessage] = useState(error_msg ? error_msg : "");
  const [entityId, setEntityId] = useState("");
  const [checkInternalTransaction, setCheckInternalTransaction] =
    useState(false);
  const [internalAccountDetailpop, setInternalAccountDetailpop] =
    useState(false);
  const [modalType, setModalType] = useState("");
  const [labelDetails, setLabelDetails] = useState([]);
  const [labels, setLabels] = useState([]);
  const [showLabelsPopup, setShowLabelsPopup] = useState(false);
  const [labelPopupLoading, setLabelPopupLoading] = useState(false);
  const [btnClicked, setbtnClicked] = useState({});

  const [opentimelinepopup, SetopenTimelinePopup] = useState(false);
  const [rightHeight, setRightHeight] = useState("auto");

  const [index, setIndex] = useState(
    showDetails
      ? GlobalConfiguration?.lengthCheckZero
      : showAdditionalDetails
        ? GlobalConfiguration?.lengthCheckOne
        : showLabel
          ? GlobalConfiguration?.lengthCheckTwo
          : GlobalConfiguration?.lengthCheckZero,
  );
  const [prevIndex, setPrevIndex] = useState(
    GlobalConfiguration?.lengthCheckZero,
  );
  // const [openApprovalTimeline, setOpenApprovalTimeline] = useState(
  //   Array(
  //     viewInternalTxnDetails?.[GlobalConfiguration.lengthCheckZero]?.logs
  //       ?.length || GlobalConfiguration?.lengthCheckZero,
  //   ).fill(false),
  // );

  // const [openDistributionTimeline, setOpenDistributionTimeline] = useState(
  //   Array(
  //     viewInternalTxnDetails?.[GlobalConfiguration.lengthCheckZero]
  //       ?.distribution_logs?.length || GlobalConfiguration?.lengthCheckZero,
  //   ).fill(false),
  // );

  const [openApprovalTimeline, setOpenApprovalTimeline] = useState([]);
  const [openDistributionTimeline, setOpenDistributionTimeline] = useState([]);

  const resetAllTimelines = () => {
    setOpenApprovalTimeline(
      new Array(
        viewInternalTxnDetails?.[GlobalConfiguration.lengthCheckZero]?.logs
          ?.length || GlobalConfiguration.lengthCheckZero,
      ).fill(false),
    );
    setOpenDistributionTimeline(
      new Array(
        viewInternalTxnDetails?.[GlobalConfiguration.lengthCheckZero]
          ?.distribution_logs?.length || GlobalConfiguration.lengthCheckZero,
      ).fill(false),
    );
  };
  const [animationClass, setAnimationClass] = useState("");
  const [ownerDetailpop, setOwnerDetailpop] = useState(false);
  const [internalAccDetailOpen, setInternalAccDetailOpen] = useState(false);

  const { services, isLoading } = useSelector((state) => state.refreshToken);
  const { internalTxnDataLoading, internalTxnData } = useSelector(
    (state) => state.internalTxnViewData,
  );

  const rejectedTnx =
    viewInternalTxnDetails?.[0]?.lifecycle_status === "rejected";

  // console.log("rjTnx", rejectedTnx);

  const hasConfidential = services?.includes("VConfidentialTxn");
  const loginid = JSON.parse(sessionStorage.getItem("response"));
  const hasCreateService = services?.includes("CInternalTxn");

  async function fetchData() {
    if (internalTxnDataLoading) setLoading(true);
    try {
      let response;
      if (type === "internal_txn_detail_modal") {
        response = await dispatch(internalTxnAccountDetail(internal_txn_id));
        setLabelDetails(
          response?.payload?.transaction?.[GlobalConfiguration.lengthCheckZero]
            ?.labels || [],
        );
      } else {
        response = await dispatch(internalTxnAccountDetail(id));

        setLabelDetails(
          response?.payload?.transaction?.[GlobalConfiguration.lengthCheckZero]
            ?.labels || [],
        );
      }
      if (
        !response?.payload ||
        response?.error?.status === errorcode.errorNotFound ||
        response?.error?.status === errorcode.errorUnAuthorized
      ) {
        navigate("/*");
        return;
      }
    } catch (error) {
      console.error("Failed to load the account details", error);
    } finally {
      setLoading(false);
    }
  }

  const openTransactionHistory = () => {
    setOpenTransHistory(true);
  };

  const closeTransactionHistory = () => {
    setOpenTransHistory(false);
  };

  const handleDeclinedDetails = (id) => {
    setInternalTxnDetailID(id);
    setShowDeclineModal(true);
  };

  const closeDeclineModal = (id) => {
    setShowDeclineModal(false);
    setbtnClicked(() => ({
      // ...prev,
      [internalTxnData.txn_id]: "none",
    }));
  };

  const closeBeneAccountDetailModal = () => {
    setInternalAccountDetailpop(false);
  };

  const updateAllAccounts = (updatedAccounts) => {
    setViewInternalTxnDetails(updatedAccounts);
  };

  const handleApprovalTimeline = (index) => {
    setOpenApprovalTimeline((prevOpenDivs) => {
      if (!Array.isArray(prevOpenDivs)) {
        return [];
      }
      const newOpenDivs = [...prevOpenDivs];
      newOpenDivs[index] = !newOpenDivs[index];
      return newOpenDivs;
    });
    setOpenDistributionTimeline(
      Array(
        viewInternalTxnDetails?.[GlobalConfiguration.lengthCheckZero]
          ?.distribution_logs?.length,
      ).fill(false),
    );
    if (!openApprovalTimeline[index]) {
      setTimeout(() => {
        cardRefs.current[index]?.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }, IntervalConfiguration.intervalExtraSmall);
    }
  };

  const handleDistributionTimeline = (index) => {
    setOpenDistributionTimeline((prevOpenDivs) => {
      if (!Array.isArray(prevOpenDivs)) {
        return [];
      }
      const newOpenDivs = [...prevOpenDivs];
      newOpenDivs[index] = !newOpenDivs[index];
      return newOpenDivs;
    });
    setTimeout(() => {
      if (cardRefsDist.current[index]) {
        cardRefsDist.current[index].scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }
    }, IntervalConfiguration.intervalExtraSmall);
  };

  const actionRestricted = () => {
    CommonToast({
      text: "Action restricted in popup mode.",
      icon: ICONS?.ERROR_WHITE_CIRCLE,
      variant: "var(--error)",
    });
  };

  const handleDistributionClick = () => {
    SetopenTimelinePopup(true);
    setShowDistributionTimeline(true);
    if (!showDistributionTimeline) {
      setShowDetails(true);
      setShowAdditionalDetails(false);
      setShowApprovalTimeline(false);
      setShowLabel(false);
    }
    setOpenApprovalTimeline(false);
  };

  const additional_data =
    internalTxnData?.transaction?.[GlobalConfiguration.lengthCheckZero]
      ?.additional_data;

  const validItems = additional_data?.data ? additional_data?.data : [];

  const attachments = validItems.filter(
    (obj) =>
      (obj.name === "Hyperlink" || obj.name === "File") && "value" in obj,
  );

  const showAmountInfo = (e) => {
    setInfoBox(!infoBox);
  };
  const closeModal = () => {
    if (infoBox) {
      setInfoBox(false);
    }
  };

  const toggleDetails = () => {
    setShowDetails(true);
    setShowAdditionalDetails(false);
    setShowLabel(false);
  };

  const toggleLabels = () => {
    setShowLabel(true);
    setShowDetails(false);
    setShowAdditionalDetails(false);
  };

  const toggleAdditionalDetails = () => {
    setShowAdditionalDetails(true);
    setShowDetails(false);
    setShowLabel(false);
  };

  const handleApproveInternalTransaction = async (id) => {
    setbtnClicked((prev) => ({
      ...prev,
      [id]: "Approve",
    }));
    UniversalRefreshToast("Approving transaction");

    setTimeout(() => {
      toast.dismiss();
    }, IntervalConfiguration?.intervalMedium);
    let res;
    if (type === "internal_txn_detail_modal") {
      res = await dispatch(internalTxnApproval(internal_txn_id));
    } else {
      res = await dispatch(internalTxnApproval(id));
    }
    if (res?.payload === undefined) {
      setNetworkError(
        "An error occured while taking action on this transaction",
      );
      setTimeout(() => {
        CommonToast({
          text: "An error occured while taking action on this transaction",
          icon: ICONS?.ERROR_WHITE_CIRCLE,
          variant: "var(--error)",
          btnProps: {
            isDisabled: false,
            enabledTextColor: "var(--text-primary)",
            enabledBgColor: "var(--primary-bg)",
          },
        });
      }, IntervalConfiguration?.intervalExtraLarge);
    } else if (
      res?.payload?.errors?.user_unauthorized?.[
        GlobalConfiguration.lengthCheckZero
      ]
    ) {
      setTimeout(() => {
        navigate("/feature_not_assigned", {
          state: {
            unavailableService: "VBeneficiaryTxn",
          },
        });
      }, IntervalConfiguration?.intervalExtraLarge);
    } else if (
      res?.payload?.status === false ||
      res.type === "beneTxnWaitingApproval/rejected"
    ) {
      if (
        res?.payload?.errors?.base?.[GlobalConfiguration.lengthCheckZero]
          ?.errors &&
        res?.payload?.errors?.base?.[GlobalConfiguration.lengthCheckZero]
          ?.errors?.[GlobalConfiguration.lengthCheckZero]?.reason
      ) {
        const error_msg =
          res?.payload?.errors?.base?.[GlobalConfiguration.lengthCheckZero]
            ?.errors?.[GlobalConfiguration.lengthCheckZero]?.reason;
        if (!Array.isArray(error_msg)) {
          setErrorMessage(error_msg);
          setTimeout(() => {
            CommonToast({
              text: error_msg,
              icon: ICONS?.ERROR_WHITE_CIRCLE,
              variant: "var(--error)",
              btnProps: {
                isDisabled: false,
                enabledTextColor: "var(--text-primary)",
                enabledBgColor: "var(--primary-bg)",
              },
            });
          }, IntervalConfiguration?.intervalMedium);
        } else {
          setErrorMessage(
            res.payload.errors.base?.[GlobalConfiguration.lengthCheckZero]
              .errors?.[GlobalConfiguration.lengthCheckZero].reason?.[
              GlobalConfiguration.lengthCheckZero
            ],
          );
          if (
            res.payload.errors.base?.[GlobalConfiguration.lengthCheckZero]
              .errors?.[GlobalConfiguration.lengthCheckZero].reason.length >=
            GlobalConfiguration?.lengthCheckOne
          ) {
            let msgs =
              res.payload.errors.base?.[GlobalConfiguration.lengthCheckZero]
                .errors?.[GlobalConfiguration.lengthCheckZero].reason;
            msgs.forEach((error) => {
              if (res?.payload?.status === false) {
                setTimeout(() => {
                  CommonToast({
                    text: error,
                    icon: ICONS?.ERROR_WHITE_CIRCLE,
                    variant: "var(--error)",
                    btnProps: {
                      isDisabled: false,
                      enabledTextColor: "var(--text-primary)",
                      enabledBgColor: "var(--primary-bg)",
                    },
                  });
                }, IntervalConfiguration?.intervalMedium);
              }
            });
          }
        }
      } else if (
        res?.payload?.errors?.base?.[GlobalConfiguration.lengthCheckZero]
          ?.reason &&
        res?.payload?.errors?.base?.[GlobalConfiguration.lengthCheckZero]
          ?.reason?.[GlobalConfiguration.lengthCheckZero]
      ) {
        setErrorMessage(
          res?.payload?.errors?.base?.[GlobalConfiguration.lengthCheckZero]
            ?.reason?.[GlobalConfiguration.lengthCheckZero],
        );
        setTimeout(() => {
          CommonToast({
            text: res?.payload?.errors?.base?.[
              GlobalConfiguration.lengthCheckZero
            ]?.reason?.[GlobalConfiguration.lengthCheckZero],
            icon: ICONS?.ERROR_WHITE_CIRCLE,
            variant: "var(--error)",
            btnProps: {
              isDisabled: false,
              enabledTextColor: "var(--text-primary)",
              enabledBgColor: "var(--primary-bg)",
            },
          });
        }, IntervalConfiguration?.intervalMedium);
      } else if (
        res?.payload?.errors?.base?.[GlobalConfiguration.lengthCheckZero]
      ) {
        setErrorMessage(
          res.payload.errors.base?.[GlobalConfiguration.lengthCheckZero],
        );
        setTimeout(() => {
          CommonToast({
            text: res.payload.errors.base?.[
              GlobalConfiguration.lengthCheckZero
            ],
            icon: ICONS?.ERROR_WHITE_CIRCLE,
            variant: "var(--error)",
            btnProps: {
              isDisabled: false,
              enabledTextColor: "var(--text-primary)",
              enabledBgColor: "var(--primary-bg)",
            },
          });
        }, IntervalConfiguration?.intervalExtraLarge);
      }
    } else {
      const approvedLifecycle =
        res?.payload?.transactions?.[GlobalConfiguration.lengthCheckZero]
          ?.lifecycle_status;
      const approvedDistributionFromRes =
        res?.payload?.transactions?.[GlobalConfiguration.lengthCheckZero]
          ?.distribution_lifecycle_status;

      const approvedDistribution =
        approvedDistributionFromRes ??
        (approvedLifecycle === "approved" ? "created" : undefined);
      const updatedData = internalTxnData?.transaction?.map((data) => {
        const resolvedLifecycle = approvedLifecycle ?? data?.lifecycle_status;
        const resolvedDistribution =
          approvedDistribution ?? data?.distribution_lifecycle_status;

        const uiState = addLifeCycleStatus({
          lifecycle_status: resolvedLifecycle,
          distribution_lifecycle_status: resolvedDistribution,
          services,
        });

        return {
          ...data,
          lifecycle_status: resolvedLifecycle,
          distribution_lifecycle_status: resolvedDistribution,
          last_updated_status:
            res?.payload?.transactions?.[GlobalConfiguration.lengthCheckZero]
              ?.last_updated_status,
          last_updated_user_id:
            res?.payload?.transactions?.[GlobalConfiguration.lengthCheckZero]
              ?.last_updated_user_id,
          ...uiState,
        };
        // return {
        //   ...data,
        //   lifecycle_status:
        //     res?.payload?.transactions?.[GlobalConfiguration.lengthCheckZero]
        //       ?.lifecycle_status,
        //   last_updated_status:
        //     res?.payload?.transactions?.[GlobalConfiguration.lengthCheckZero]
        //       ?.last_updated_status,
        //   last_updated_user_id:
        //     res?.payload?.transactions?.[GlobalConfiguration.lengthCheckZero]
        //       ?.last_updated_user_id,
        // };
      });
      setViewInternalTxnDetails(updatedData);

      if (type === "internal_txn_detail_modal") {
        let data = structuredClone(res?.payload);
        delete data.transactions;
        data.transaction = res?.payload?.transactions;
        await dispatch(updateInternalDetailData(data));
      } else {
        let data = structuredClone(res?.payload);
        delete data.transactions;
        data.transaction = res?.payload?.transactions;
        await dispatch(updateInternalDetailData(data));
      }
      if (res?.payload?.status === true) {
        if (
          type === "internal_txn_detail_modal" ||
          locationState?.state?.type === "Internal-Multi-Approval-Txn-Details"
        ) {
          let getSessionData = JSON.parse(
            sessionStorage.getItem("selectedData"),
          );

          let selectedSendTransactions =
            getSessionData?.selectedSendTransactions?.filter(
              (fil) => fil.txn_id !== id,
            );
          let selectedTransactions =
            getSessionData?.selectedTransactions?.filter((fil) => fil !== id);
          sessionStorage.setItem(
            "selectedData",
            JSON.stringify({
              selectedSendTransactions: selectedSendTransactions,
              selectedTransactions: selectedTransactions,
            }),
          );
          if (
            locationState?.state?.type === "Internal-Multi-Approval-Txn-Details"
          ) {
            if (
              selectedSendTransactions?.length ===
                GlobalConfiguration?.lengthCheckZero &&
              selectedTransactions?.length ===
                GlobalConfiguration?.lengthCheckZero
            ) {
              navigate(
                `/internal_transaction_dashboard/internal_transaction_multi_approval`,
              );
            } else {
              navigate(GlobalConfiguration?.navigate_back);
            }
          }
        }
        setTimeout(() => {
          CommonToast({
            text: "Transaction approved successfully.",
            icon: "https://q2pay.in/new_assets/common/approval/select_all_with_white_filled_circle.svg",
            variant: "var(--success)",
            btnProps: {
              isDisabled: false,
              enabledTextColor: "var(--text-primary)",
              enabledBgColor: "var(--primary-bg)",
            },
          });
        }, IntervalConfiguration?.intervalMedium);
      }
      if (type === "internal_txn_detail_modal") {
        setTimeout(() => {
          closeInternalTxnDetailModal();
          window.location.reload();
        }, IntervalConfiguration?.intervalPopup);
      }
    }
  };

  const handleRecreateConfirmation = (reason) => {
    (async () => {
      let errorMessage;
      const response = await dispatch(
        internalTxnDenied({ id: id ?? internal_txn_id, AccountIdData: reason }),
      );
      if (response?.payload?.status) {
        CommonToast({
          text: "Transaction rejected and sent for recreation.",
          icon: "https://q2pay.in/new_assets/common/approval/select_all_with_white_filled_circle.svg",
          variant: "var(--success)",
          btnProps: {
            isDisabled: false,
            enabledTextColor: "var(--text-primary)",
            enabledBgColor: "var(--primary-bg)",
          },
        });
        await fetchData();
        setNetworkError(null);
        setErrorMessage(null);
        setShowRecreatePopup(false);
      } else {
        if (
          response?.payload?.errors?.base[GlobalConfiguration.lengthCheckZero]
            ?.errors &&
          response?.payload?.errors?.base[GlobalConfiguration.lengthCheckZero]
            ?.errors[GlobalConfiguration.lengthCheckZero]
        ) {
          errorMessage =
            response.payload.errors.base[GlobalConfiguration.lengthCheckZero]
              .errors[GlobalConfiguration.lengthCheckZero];
          if (
            response?.payload?.errors?.base[GlobalConfiguration.lengthCheckZero]
              ?.errors.length >= GlobalConfiguration?.lengthCheckOne
          ) {
            let msg1 =
              response?.payload?.errors?.base[
                GlobalConfiguration.lengthCheckZero
              ]?.errors;
            msg1.forEach((error1) => {
              if (response?.payload?.status === false) {
                setTimeout(() => {
                  CommonToast({
                    text: error1,
                    icon: ICONS?.ERROR_WHITE_CIRCLE,
                    variant: "var(--error)",
                    btnProps: {
                      isDisabled: false,
                      enabledTextColor: "var(--text-primary)",
                      enabledBgColor: "var(--primary-bg)",
                    },
                  });
                }, IntervalConfiguration?.intervalMedium);
              }
            });
          }
        } else if (
          response?.payload?.errors?.base[GlobalConfiguration.lengthCheckZero]
        ) {
          errorMessage =
            response.payload.errors.base[GlobalConfiguration.lengthCheckZero];
          CommonToast({
            text: errorMessage,
            icon: ICONS?.ERROR_WHITE_CIRCLE,
            variant: "var(--error)",
            btnProps: {
              isDisabled: false,
              enabledTextColor: "var(--text-primary)",
              enabledBgColor: "var(--primary-bg)",
            },
          });
        }
        setShowRecreatePopup(false);
      }
    })();
  };

  const handleTimelinePopup = () => {
    if (type === "internal_txn_detail_modal") {
      actionRestricted();
      return;
    } else {
      SetopenTimelinePopup(true);
      setShowApprovalTimeline(true);
      if (!showApprovalTimeline) {
        setShowDetails(true);
        setShowAdditionalDetails(false);
        setShowDistributionTimeline(false);
        setShowLabel(false);
      }
      setOpenDistributionTimeline(false);
    }
  };

  const handleClose = () => {
    setShowLabelsPopup(false);
    if (!labelActionDispatchedRef.current) return;
    labelActionDispatchedRef.current = false;
    fetchData();
  };

  const labelTxnIds = [internalTxnDetailID || id || internal_txn_id].filter(
    Boolean,
  );

  const getErrorMessage = (res) => {
    const p =
      res?.payload.response.data.ids?.unsuccessful_ids[0].errors ||
      res?.payload;
    const e = res?.error;
    if (typeof p === "string") return p;
    if (p?.message) return p.message;
    if (p?.errors?.base?.[0]) {
      const base = p.errors.base[0];
      return typeof base === "string"
        ? base
        : base?.errors?.[0] || base?.message || "Something went wrong";
    }
    if (e?.message) return e.message;
    return "Something went wrong";
  };

  const handleAssignLabelsProp = async (labelsToAssign) => {
    setLabelPopupLoading(true);

    const toArray = (value) => (Array?.isArray(value) ? value : [value]);
    const recordIds = toArray(labelTxnIds);
    const res = await dispatch(
      addInternalTxnLabel({
        record_ids: recordIds,
        labels: labelsToAssign,
      }),
    );
    if (addInternalTxnLabel.fulfilled.match(res)) {
      toast.dismiss();
      CommonToast({
        text: "Labels assigned successfully.",
        icon: "https://q2pay.in/new_assets/common/approval/select_all_with_white_filled_circle.svg",
        variant: "var(--success)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
      await fetchData();
      if (labelActionDispatchedRef) labelActionDispatchedRef.current = true;
    }
    if (addInternalTxnLabel.rejected.match(res)) {
      toast.dismiss();
      CommonToast({
        text: getErrorMessage(res),
        icon: ICONS?.ERROR_WHITE_CIRCLE,
        variant: "var(--error)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
    }
    setLabelPopupLoading(false);
    if (addInternalTxnLabel?.fulfilled?.match(res)) {
      return true;
    } else {
      return false;
    }
  };

  const handleUnassignLabelsProp = async (labelsToUnassign) => {
    setLabelPopupLoading(true);

    const toArray = (value) => (Array.isArray(value) ? value : [value]);
    const recordIds = toArray(labelTxnIds);
    const res = await dispatch(
      removeInternalTxnLabel({
        record_ids: recordIds,
        labels: labelsToUnassign,
      }),
    );
    if (removeInternalTxnLabel.fulfilled.match(res)) {
      toast.dismiss();
      CommonToast({
        text: "Labels unassigned successfully.",
        icon: "https://q2pay.in/new_assets/common/approval/select_all_with_white_filled_circle.svg",
        variant: "var(--success)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
      await fetchData();
      if (labelActionDispatchedRef) labelActionDispatchedRef.current = true;
    }
    if (removeInternalTxnLabel.rejected.match(res)) {
      toast.dismiss();
      CommonToast({
        text: getErrorMessage(res),
        icon: ICONS?.ERROR_WHITE_CIRCLE,
        variant: "var(--error)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
    }
    setLabelPopupLoading(false);
    if (removeInternalTxnLabel?.fulfilled?.match(res)) {
      return true;
    } else {
      return false;
    }
  };

  const PopupcloseIcons = () => {
    resetAllTimelines();
    SetopenTimelinePopup(false);
    setShowApprovalTimeline(false);
    setShowDistributionTimeline(false);
  };

  useLayoutEffect(() => {
    if (index !== prevIndex) {
      const direction =
        index > prevIndex ? "animate-slide-next" : "animate-slide-prev";

      setAnimationClass(direction);
      setPrevIndex(index);
    }
  }, [index]);

  useEffect(() => {
    fetchData();
    let availableLabels = sessionStorage?.getItem("AvailableLabelsInternalTxn");
    const parsedLabels = JSON?.parse(availableLabels);
    setLabels(parsedLabels);
  }, [id, dispatch]);

  // useEffect(() => {
  //   fetchData();
  // }, [dispatch]);

  // useEffect(() => {
  //   fetchData();
  // }, [dispatch, id]);

  useEffect(() => {
    dispatch(disableSwitcher());
    // The next lines are commented out as a deliberate reminder to not re
    // enable the switcher when exiting this page since it will be re enabled by
    // whereever one may navigate anyways

    // return () => {
    //   dispatch(enableSwitcher());
    // }
  }, []);
  useEffect(() => {
    const updateHeight = () => {
      setRightHeight(leftContentRef?.current?.offsetHeight);
    };

    updateHeight();

    window.addEventListener("resize", updateHeight);
    return () => window.removeEventListener("resize", updateHeight);
  }, [viewInternalTxnDetails]);
  useEffect(() => {
    if (internalTxnData) {
      const uiState = addLifeCycleStatus({
        lifecycle_status:
          internalTxnData?.transaction[GlobalConfiguration.lengthCheckZero]
            ?.lifecycle_status,
        distribution_lifecycle_status:
          internalTxnData?.transaction[GlobalConfiguration.lengthCheckZero]
            ?.distribution_lifecycle_status,
        services,
        previousStatus: previousStatus,
      });
      const newData = internalTxnData?.transaction?.map((account) => ({
        ...account,
        loading: false,
        error: false,
        message: "",
        last_updated_user_id_check: false,
        ...uiState,
      }));
      setViewInternalTxnDetails(newData);
      setEntityId(
        internalTxnData?.transaction?.[GlobalConfiguration.lengthCheckZero]
          ?.entity_id,
      );
      setInternalTxnDetailID(
        internalTxnData?.transaction?.[GlobalConfiguration.lengthCheckZero]
          ?.txn_id,
      );
      setInternalAccountID(
        internalTxnData?.transaction?.[GlobalConfiguration.lengthCheckZero]
          ?.internal_account_id,
      );
    }
  }, [internalTxnData]);

  useEffect(() => {
    const fetchTotalPages = async () => {
      try {
        let response = null;
        if (entityId) {
          response = await dispatch(
            internalTxnRequireApprovalPage({
              entityId: entityId,
              page_no: GlobalConfiguration.lengthCheckOne,
            }),
          );
        }
        const total_pages =
          response?.payload?.title?.total_pages ||
          GlobalConfiguration.lengthCheckOne;
        setPages(total_pages);
      } catch (err) {
        setLoading(false);
      }
    };

    fetchTotalPages();
  }, []);

  useEffect(() => {
    const fetchAllData = async () => {
      if (!pages) return;
      let allTransactions = [];

      setLoadingBox(true);
      for (
        let page = GlobalConfiguration.lengthCheckOne;
        page <= pages;
        page++
      ) {
        try {
          let response = null;
          if (
            entityId &&
            internalTxnData?.transaction?.[GlobalConfiguration.lengthCheckZero]
              ?.lifecycle_status === "pending"
          ) {
            response = await dispatch(
              internalTxnRequireApprovalPage({
                entityId: entityId,
                page_no: page,
              }),
            );
          }

          const transactionsData = response?.payload?.transactions || [];
          allTransactions = [...allTransactions, ...transactionsData];
        } catch (error) {
          console.error(`Error fetching data for page ${page}:`, error);
          break;
        }
      }
      const transactionExists = allTransactions.some(
        (obj) => obj.txn_id === internalTxnDetailID,
      );
      if (transactionExists) {
        setCheckInternalTransaction(transactionExists);
      }
      setLoadingBox(false);
    };
    fetchAllData();
  }, [dispatch, entityId, internalTxnDetailID, pages]);

  const transactionHistory =
    "https://q2pay.in/new_assets/common/detail_page/transaction_history.svg";

  const label =
    "https://q2pay.in/new_assets/common/detail_page/label_with_white_circle.svg";

  const arrow_right_black =
    "https://q2pay.in/new_assets/common/arrows/arrow_right_blue_white.svg";

  const confidential_transactionImg =
    "https://q2pay.in/new_assets/common/detail_page/confidential_transaction.svg";

  const arrowLeftimg =
    "https://q2pay.in/new_assets/common/arrows/arrow_left_white.svg";

  const arrowDownBlueWhite =
    "https://q2pay.in/new_assets/common/arrows/arrow_down_blue_white.svg";

  return (
    <>
      {showLabelsPopup && (
        <div
          onClick={(e) => {
            e.stopPropagation();
            setShowLabelsPopup(true);
          }}
          className="fixed top-top-base left-left-base w-width-full h-height-full flex items-center bg-PopUp-BackDrop justify-center z-z-index-modal bg-opacity-dark-opacity"
        >
          <CommonAssignLabelPopup
            headerTitle="Assign/unassign labels:"
            headersubtext="Labels will be used to generate statistics for the associated transactions."
            closehandleFunction={handleClose}
            closeisDisabled={false}
            labels={labels}
            setLabels={setLabels}
            LabelAccounts={labelTxnIds}
            isLabelPopupOpen={showLabelsPopup}
            filteredData={(internalTxnData?.transaction || [])
              ?.filter((t) => labelTxnIds.includes(t.txn_id))
              ?.map((t) => ({ ...t, id: t.txn_id }))}
            onClose={handleClose}
            loading={labelPopupLoading}
            setLoading={setLabelPopupLoading}
            handleAssignLabels={handleAssignLabelsProp}
            handleUnassignLabels={handleUnassignLabelsProp}
            type="viewall"
          />
        </div>
      )}
      {ownerDetailpop && (
        <div className="fixed top-top-base left-left-base w-screen h-screen z-z-index-modal bg-Primary-black bg-opacity-dark-opacity">
          <OwnerAccountDetailsPopUp
            closeBeneAccountDetailModal={() => {
              setOwnerDetailpop(false);
            }}
            Remibursement_owneraccount_id={
              internalTxnData?.transaction?.[0]?.owner_account_id
            }
            type={"reimburseowner_details"}
          />
        </div>
      )}
      {internalAccDetailOpen ? (
        <div className="fixed top-top-base left-left-base w-screen h-screen flex items-center justify-center z-z-index-modal bg-PopUp-BackDrop bg-opacity-dark-opacity">
          <InternalAccDetailsPopUp
            closeBeneAccountDetailModal={() => setInternalAccDetailOpen(false)}
            bene_account_id={
              internalTxnData?.transaction?.[0]?.internal_account_id
            }
            type={"bene_account_detail_modal"}
            internalAccDetailOpen={internalAccDetailOpen}
            openTransHistory={openTransHistory}
          />
        </div>
      ) : null}
      {opentimelinepopup && (
        <>
          <div className="fixed top-top-base left-left-base w-width-full h-height-full flex items-center bg-PopUp-BackDrop justify-center z-z-index-modal bg-opacity-dark-opacity">
            <LargePopupRedirect
              headerTitle="Transaction timeline"
              headerFontWeight="semibold"
              headerFontColor="text-primary"
              headertextSize="font-md"
              closeiconenabledBgColor="var(--primary-nav)"
              closeiconisLoading={false}
              closeiconhandleFunction={PopupcloseIcons}
              closeicon={
                "https://q2pay.in/new_assets/common/create_flow/close.svg"
              }
              closeiconhoverOption="white"
              closeiconbtnType={"button"}
              closeiconisDisabled={false}
              closeicondisabledBgColor={""}
              closeiconbuttonRef={null}
              closeicontitle={"Close"}
              btnType={"button"}
              handleFunction={() => {}}
              enabledBgColor={"var(--positive-act)"}
              hoverOption={"dark"}
              outLineColor={""}
              enabledTextColor={"var(--text-primary)"}
              fullWidthRequired={false}
              isDisabled={false}
              disabledTextColor={""}
              disabledBgColor={""}
              isLoading={false}
              buttonRef={null}
              inActiveVariantNeeded={false}
              isLoaderNeeded={false}
              isscrollRequired={true}
            >
              <TimelinePopupContent
                logsData={viewInternalTxnDetails}
                handleApprovalClick={handleTimelinePopup}
                handleDistributionClick={handleDistributionClick}
                showDistributionRightIcon={false}
                showApprovalLeftIcon={false}
                showApprovalTimeline={showApprovalTimeline}
                openApprovalTimeline={openApprovalTimeline}
                handleApprovalTimeline={handleApprovalTimeline}
                showDistributionTimeline={showDistributionTimeline}
                openDistributionTimeline={openDistributionTimeline}
                handleDistributionTimeline={handleDistributionTimeline}
                setOpenDistributionTimeline={setOpenDistributionTimeline}
                setOpenApprovalTimeline={setOpenApprovalTimeline}
                cardType={"double"}
                popUpMode={true}
              />
            </LargePopupRedirect>
          </div>
        </>
      )}
      {alertPopUp && (
        <div className="fixed top-top-base left-left-base w-width-full h-height-full flex items-center bg-PopUp-BackDrop justify-center z-z-index-modal bg-opacity-dark-opacity">
          <FullScreen
            type={"internalTxn"}
            id={internal_txn_id}
            setAlertPopUp={setAlertPopUp}
          />
        </div>
      )}

      {/* {showRecreatePopup && (
        <div className="fixed top-top-base left-left-base w-width-full h-height-full flex items-center bg-PopUp-BackDrop justify-center z-z-index-modal bg-opacity-dark-opacity">
          <RecreatePromptModalPopup
            onConfirmBtnClick={handleRecreateConfirmation}
            onClose={() => {
              setShowRecreatePopup(false);
            }}
            onCancelBtnClick={() => {
              setShowRecreatePopup(false);
            }}
          />
        </div>
      )} */}
      <div
        className="bg-primary-bg overflow-x-hidden"
        style={{
          height:
            type === "internal_txn_detail_modal"
              ? "var(--height-full)"
              : "var(--full-height)",
          overflowY: openTransHistory ? "hidden" : "auto",
        }}
        onClick={closeModal}
      >
        {loading ? (
          <div className="fixed inset-0 flex  items-center justify-center m-auto ">
            <Loader />
          </div>
        ) : (
          <>
            {type !== "internal_txn_detail_modal" && (
              <div className="Qsmd:flex hidden h-fixed-header mt-margin-lg bg-primary-nav w-width-full" />
            )}

            <div
              className={`internalTxnDetailsPage bg-primary-nav block lg:hidden ${type === "internal_txn_detail_modal" ? "" : "Qmd:mt-margin-base"}`}
            >
              <div
                className={`bg-primary-nav shadow-box-shadow-bottom fixed top-top-base left-left-base z-z-index-tooltip w-width-full block ${
                  type === "internal_txn_detail_modal" ? "hidden" : "lg:hidden"
                }`}
              >
                <TopNavComponent
                  isFormattingNotRequired={true}
                  topNavHeader={"Internal Transaction"}
                  topNavSubText="Transaction detail"
                />
              </div>

              {openTransHistory && (
                <div className="fixed top-top-base left-left-base w-screen h-screen z-z-index-modal bg-PopUp-BackDrop bg-opacity-dark-opacity">
                  <LargePopupRedirect
                    headerTitle={
                      modalType === "Confidential transaction"
                        ? "Confidential transaction"
                        : "Transaction history"
                    }
                    headersubtext={
                      modalType === "Confidential transaction"
                        ? "All confidential transactions related to the destination account and source account are listed below."
                        : "All transactions related to the destination account and source account are listed below."
                    }
                    closeiconenabledBgColor="var(--primary-nav)"
                    closeiconisLoading={false}
                    closeiconhandleFunction={() => closeTransactionHistory()}
                    closeicon={
                      "https://q2pay.in/new_assets/common/create_flow/close.svg"
                    }
                    closeiconhoverOption="white"
                    closeiconbtnType={"button"}
                    closeiconisDisabled={false}
                    closeicondisabledBgColor={""}
                    closeiconbuttonRef={null}
                    closeicontitle={"Close"}
                    btnType={"button"}
                    enabledBgColor={"var(--negative-act)"}
                    hoverOption={"dark"}
                    outLineColor={""}
                    enabledTextColor={"var(--text-primary)"}
                    fullWidthRequired={false}
                    isDisabled={false}
                    disabledTextColor={""}
                    disabledBgColor={""}
                  >
                    <InternalTransactionViewAll
                      loading={loading}
                      setLoading={setLoading}
                      setOpenTransHistory={setOpenTransHistory}
                      openTransHistory={openTransHistory}
                      owner_account_id={
                        internalTxnData?.transaction?.[
                          GlobalConfiguration.lengthCheckZero
                        ]?.owner_account_id
                      }
                      BeneAccId={
                        internalTxnData?.transaction?.[
                          GlobalConfiguration.lengthCheckZero
                        ]?.internal_account_id
                      }
                      owner_account_bank_acc_no={
                        internalTxnData?.transaction?.[
                          GlobalConfiguration.lengthCheckZero
                        ]?.owner_account_bank_acc_no
                      }
                      internal_account_confidential={
                        modalType === "Confidential transaction"
                          ? internalTxnData?.transaction?.[
                              GlobalConfiguration.lengthCheckZero
                            ]?.confidential_transaction
                          : null
                      }
                      txnHistorytype={"internalTxnHistory"}
                      popup={modalType}
                      onClose={closeTransactionHistory}
                    />
                  </LargePopupRedirect>
                </div>
              )}

              {internalAccountDetailpop && (
                <div
                  className="fixed top-top-base left-left-base w-screen h-screen z-z-index-modal bg-PopUp-BackDrop bg-opacity-dark-opacity"
                  onClick={() => {
                    closeBeneAccountDetailModal();
                  }}
                >
                  <InternalAccDetailsPopUp
                    closeBeneAccountDetailModal={closeBeneAccountDetailModal}
                    bene_account_id={internalAccountID}
                    type={"bene_account_detail_modal"}
                    flowType={"internalAccount"}
                  />
                </div>
              )}

              {showDeclineModal && (
                <InternalTxnDeclinePopup
                  handleClose={closeDeclineModal}
                  txnId={internalTxnDetailID}
                  allTxnData={viewInternalTxnDetails}
                  updateAllTxn={updateAllAccounts}
                  addLifeCycleStatus={addLifeCycleStatus}
                  onRejectSuccess={() => {
                    if (type === "internal_txn_detail_modal") {
                      closeInternalTxnDetailModal();
                      window.location.reload();
                    }
                  }}
                />
              )}

              <div
                className={`internaltxn-account-primary-details Qsmd:mt-margin-base  ${type === "internal_txn_detail_modal" ? "" : "Qsmd:pt-padding-xs mt-margin-lg Qsmd:mt-margin-base  "}  lg:px-padding-sm`}
              >
                {internalTxnData?.transaction?.map((account) => (
                  <div
                    key={account.txn_id}
                    className={`w-width-full h-auto  pt-padding-base mt-margin-base lg:mt-margin-base Qmd:pt-padding-base ${
                      type === "internal_txn_detail_modal"
                        ? ""
                        : "Qsmd:mt-margin-base mt-margin-lg Qmd:pt-padding-base lg:pt-padding-base"
                    }`}
                    style={{
                      marginLeft: "auto",
                      marginRight: "auto",
                      maxWidth: "var(--max-content-width)",
                    }}
                  >
                    <div className="flex flex-col lg:flex-row mx-margin-md lg:mx-margin-base">
                      <div className="flex flex-row my-margin-md Qlg:mt-margin-md mt-margin-sm w-width-full lg:w-width-md justify-between px-padding-base lg:px-padding-base relative">
                        <div className="flex flex-col mt-margin-xs lg:px-padding-sm relative">
                          <div className="flex flex-row gap-x-gap-xs relative">
                            <div>
                              <TitleSubtitlePair
                                title={`INR ${formatCurrency(account.total_amount)}`}
                                titleColor="settled"
                                subtitle="Amount"
                                info={true}
                                onClick={showAmountInfo}
                                alignRight={false}
                                hoverOption="white"
                                isBold={true}
                                variant="md"
                              />
                            </div>
                            {infoBox && (
                              <div className="fixed top-top-base left-left-base w-width-full h-height-full flex items-center bg-PopUp-BackDrop justify-center z-z-index-modal bg-opacity-dark-opacity">
                                <CommonInfoBox
                                  headerTitle="Amount Breakdown"
                                  headerFontColor="text-primary"
                                  headerFontWeight="semibold"
                                  textSize="font-md"
                                  onClosepop={closeModal}
                                  popupBgColor="primary-bg"
                                  transactionLabel="Transaction amount"
                                  transactionAmount={account.total_amount}
                                  finalAmountLabel="Amount credited"
                                  rows={[
                                    {
                                      label: "Amount debited",
                                      value: account.total_amount,
                                      operation: "add",
                                      icon: "https://q2pay.in/new_assets/common/settings/subtraction_with_roundness.svg",
                                    },
                                    {
                                      label: "Tax amount",
                                      value: account.tax_amount,
                                      operation: "add",
                                      icon: "https://q2pay.in/new_assets/common/settings/subtraction_with_roundness.svg",
                                    },
                                    {
                                      label: "Payment charge",
                                      value: account.payment_charge,
                                      operation: "add",
                                    },
                                  ]}
                                />
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="lg:border-l border-b lg:border-b-border-base border-solid border-primary-bg lg:my-margin-md "></div>
                      <div className="flex flex-row justify-between items-center py-padding-md lg:py-padding-base  w-width-full lg:w-width-md px-padding-base lg:px-padding-base">
                        <div className=" mt-margin-xs lg:p-padding-sm lg:ml-margin-sm ml-0">
                          <TitleSubtitlePair
                            isDisabled={false}
                            alignRight={false}
                            title={accountNameStandardised(
                              account?.internal_account_name,
                            )}
                            titleColor={"text-primary"}
                            subtitle={"Account name"}
                            info={false}
                            showArrow={false}
                            isBold={false}
                            variant={"md"}
                            textAlign="left"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="border-b-border border-primary-bg px-padding-button-l Qsmd:px-padding-base lg:ml-margin-sm mx-margin-md lg:mx-margin-base "></div>
                    <div className="relative lg:mx-margin-base mx-margin-sm">
                      <div className="flex flex-col lg:flex-row">
                        <div className="flex flex-row pt-padding-sm w-width-full lg:w-width-md justify-between lg:px-padding-base pl-padding-base lg:pr-padding-md lg:pl-padding-base">
                          <div>
                            <TitleSubtitlePair
                              isDisabled={
                                type === "internal_txn_detail_modal"
                                  ? true
                                  : false
                              }
                              alignRight={false}
                              title={formatAccountNumber(
                                account?.owner_account_bank_acc_no,
                              )}
                              titleColor={"text-primary"}
                              subtitle={"Source account"}
                              onClick={() => {
                                if (type === "internal_txn_detail_modal") {
                                  actionRestricted();
                                  return;
                                }

                                if (services?.includes("VAccount")) {
                                  // navigate(
                                  //   `/owner_account_dashboard/owner_accounts_view_all/owner_accounts_detail_page/${account.owner_account_id}`,
                                  // );
                                  setOwnerDetailpop(true);
                                } else {
                                  navigate("/feature_not_assigned", {
                                    state: {
                                      unavailableService: "VAccount",
                                    },
                                  });
                                }
                              }}
                              info={false}
                              showArrow={true}
                              hoverOption={"white"}
                              isBold={false}
                              variant={"md"}
                            />
                          </div>
                          <div className="bg-text-primary rounded-border-radius-md flex items-center justify-around h-toggle-btn-height px-padding-sm mt-margin-md lg:mr-margin-md mr-margin-sm">
                            <CommonBankLogo
                              ifsc={account.owner_account_ifsc_code}
                              variant="big"
                              type="pill"
                            />
                          </div>
                        </div>
                        <div>
                          <div className="border-l border-solid border-primary-bg mt-margin-md h-pagination-height hidden lg:block "></div>
                        </div>

                        <div className="flex items-center gap-gap-sm justify-between  lg:hidden mx-margin-sm lg:mx-margin-base">
                          <div className="w-width-md border-b border-primary-bg "></div>
                          <div className="w-icon-lg">
                            <img
                              src={arrowDownBlueWhite}
                              alt="arrowDownBlueWhite"
                            />
                          </div>
                          <div className="w-width-md border-b border-primary-bg "></div>
                        </div>
                        <div className="w-width-full lg:w-width-md flex justify-between gap-gap-md items-center">
                          <div className="flex flex-row lg:pt-padding-sm pb-padding-md lg:pb-padding-base w-width-full lg:w-width-lg justify-between px-padding-sm lg:px-padding-base gap-gap-sm">
                            <div className="lg:ml-margin-sm ml-[calc(-1*var(--margin-sm))]">
                              <TitleSubtitlePair
                                isDisabled={
                                  type === "internal_txn_detail_modal"
                                    ? true
                                    : false
                                }
                                alignRight={false}
                                title={formatAccountNumber(
                                  account?.internal_account_bank_acc_no,
                                )}
                                titleColor={"text-primary"}
                                subtitle={"Destination account"}
                                onClick={() => {
                                  if (type === "internal_txn_detail_modal") {
                                    actionRestricted();
                                    return;
                                  }
                                  if (services?.includes("IVAccount")) {
                                    setInternalAccDetailOpen(true);
                                  } else {
                                    navigate("/feature_not_assigned", {
                                      state: {
                                        unavailableService: "IVAccount",
                                      },
                                    });
                                  }
                                }}
                                info={false}
                                showArrow={true}
                                hoverOption={"white"}
                                isBold={false}
                                variant={"md"}
                              />
                            </div>
                          </div>

                          <div className="bg-text-primary rounded-border-radius-md flex items-center justify-around h-toggle-btn-height px-padding-sm mt-margin-md lg:mr-margin-md mr-margin-sm">
                            <CommonBankLogo
                              ifsc={account?.internal_account_ifsc_code}
                              variant="big"
                              type="pill"
                            />
                          </div>

                          <div className="hidden lg:flex">
                            {hasConfidential &&
                            internalTxnData?.transaction?.[
                              GlobalConfiguration.lengthCheckZero
                            ]?.confidential_transaction === "Y" ? (
                              <div className="hidden lg:flex ml-margin-xl">
                                <TopNavSmallButton
                                  btnText={
                                    <>
                                      {" "}
                                      Confidential <br /> transactions
                                    </>
                                  }
                                  handleFunction={() => {
                                    if (type === "internal_txn_detail_modal") {
                                      actionRestricted();
                                    } else {
                                      openTransactionHistory();
                                      setModalType("Confidential transaction");
                                    }
                                  }}
                                  icon={confidential_transactionImg}
                                  enabledBgColor={"var(--primary-nav-act)"}
                                  enabledTextColor={"var(--text-primary)"}
                                  hoverOption="white"
                                  isDisabled={
                                    type === "internal_txn_detail_modal"
                                  }
                                />
                              </div>
                            ) : (
                              <div
                                className={
                                  " min-w-splitview-btn-width hidden lg:flex"
                                }
                              ></div>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="lg:flex justify-end items-center hidden z-z-index-content absolute top-[var(--ifsc-img-width)] w-width-md ml-margin-sm">
                        <img
                          src={arrow_right_black}
                          className="h-icon-md my-margin-sm"
                          alt="Internal_Transaction_Arrow"
                        />
                      </div>
                    </div>
                    <div className="lg:border-l border-b lg:border-b-border-base border-solid border-primary-bg block lg:hidden mt-margin-base mx-margin-md lg:mx-margin-base"></div>
                    <div className="flex flex-col lg:flex-row mx-margin-md  lg:mx-margin-base">
                      <div className="flex flex-row py-padding-md w-width-full lg:w-width-md  lg:px-padding-base justify-between lg:mt-margin-xs lg:pt-padding-sm lg:pb-padding-md">
                        <div className="mt-margin-xs lg:px-padding-sm">
                          <TitleSubtitlePair
                            isDisabled={false}
                            alignRight={false}
                            title={account?.owner_account_ifsc_code}
                            titleColor={"text-primary"}
                            subtitle={"IFSC code"}
                            info={false}
                            showArrow={false}
                            isBold={false}
                            variant={"md"}
                          />
                        </div>
                        <div className="mt-margin-xs lg:mr-margin-md">
                          <TitleSubtitlePair
                            isDisabled={false}
                            alignRight={true}
                            title={account?.payment_method ?? "N/A"}
                            titleColor={"text-primary"}
                            subtitle={"Payment method"}
                            info={false}
                            showArrow={false}
                            isBold={false}
                            variant={"md"}
                            textAlign="right"
                          />
                        </div>
                      </div>
                      <div className="lg:border-l border-b lg:border-b-border-base border-solid border-primary-bg lg:mt-margin-button-l m-margin-base lg:mb-margin-md  Qlg:mx-margin-base"></div>
                      <div
                        className={` w-width-full lg:w-width-md  lg:px-padding-base py-padding-md lg:border-border-base  border-primary-bg  lg:py-padding-base flex flex-row justify-between  `}
                      >
                        <div
                          className={`box_with_confidential Qlg:w-width_xl justify-between   gap-gap-md flex lg:pt-padding-sm lg:mt-margin-xs lg:pb-padding-md ${
                            hasConfidential &&
                            internalTxnData?.transaction?.[
                              GlobalConfiguration.lengthCheckZero
                            ]?.confidential_transaction === "Y"
                              ? "lg:w-width-full"
                              : ""
                          }`}
                        >
                          <div className="mt-margin-xs lg:ml-margin-md w-width-md">
                            <TitleSubtitlePair
                              isDisabled={false}
                              alignRight={false}
                              title={account?.internal_account_ifsc_code}
                              titleColor={"text-primary"}
                              subtitle={"IFSC code"}
                              info={false}
                              showArrow={false}
                              isBold={false}
                              variant={"md"}
                            />
                          </div>
                        </div>

                        <div className="hidden lg:flex h-height-full">
                          <TopNavSmallButton
                            btnText={
                              <>
                                {" "}
                                Transaction <br /> history
                              </>
                            }
                            handleFunction={() => {
                              if (type === "internal_txn_detail_modal") {
                                actionRestricted();
                              } else {
                                openTransactionHistory();
                                setModalType("Transaction history");
                              }
                            }}
                            icon={transactionHistory}
                            enabledBgColor={"var(--primary-nav-act)"}
                            enabledTextColor={"var(--text-primary)"}
                            hoverOption="white"
                            isDisabled={type === "internal_txn_detail_modal"}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              <div className="w-screen  bg-primary-bg block lg:hidden">
                <div className="flex flex-col w-width-full m-auto">
                  <div className="flex flex-row w-width-full m-auto">
                    {/* Mobile  */}
                    <TimelineStatusBar
                      showMobile={true}
                      overrideAutoLoader
                      key={
                        viewInternalTxnDetails?.[
                          GlobalConfiguration.lengthCheckZero
                        ]?.txn_id
                      }
                      isLoading={
                        loadingBox &&
                        viewInternalTxnDetails?.[
                          GlobalConfiguration.lengthCheckZero
                        ]?.lifecycle_status === "pending"
                      }
                      approvalNotPossible={
                        networkError ||
                        errorMessage ||
                        viewInternalTxnDetails?.[
                          GlobalConfiguration.lengthCheckZero
                        ]?.message
                      }
                      approvalNotPossibleIcon={true}
                      handleApprovalNotPossibleBtn={() => {
                        if (services?.includes("AInternalTxn")) {
                          CommonToast({
                            text: "Feature coming soon",
                            icon: "https://q2pay.in/new_assets/common/detail_page/info.svg",
                            variant: "var(--coming-soon)",
                            buttonNeeded: false,
                          });
                          // setShowRecreatePopup(true);
                        } else {
                          navigate("/feature_not_assigned", {
                            state: {
                              unavailableService: "AInternalTxn",
                            },
                          });
                        }
                      }}
                      isApprovalNotPossibleDisabled={false}
                      furtherApprovalPending={
                        (viewInternalTxnDetails?.[0]?.last_updated_status ===
                          "Approved" &&
                          viewInternalTxnDetails?.[0]?.lifecycle_status ===
                            "pending" &&
                          viewInternalTxnDetails?.[0]?.last_updated_user_id ===
                            loginid?.employees?.id) ||
                        (viewInternalTxnDetails?.[0]?.last_updated_status ===
                          "Approved" &&
                          viewInternalTxnDetails?.[0]?.lifecycle_status ===
                            "pending" &&
                          services?.find(
                            (service) => service === "AInternalTxn",
                          ) === undefined)
                      }
                      // furtherApprovalPendingSubHeader={
                      //   viewInternalTxnDetails?.[0]?.last_updated_status ===
                      //     "Approved" &&
                      //   viewInternalTxnDetails?.[0]?.lifecycle_status ===
                      //     "pending"
                      //     ? viewInternalTxnDetails?.[0]
                      //         ?.last_updated_user_id === loginid?.employees?.id
                      //       ? "This transaction has been approved by you, but it requires another user's approval before distribution."
                      //       : services?.find(
                      //             (service) => service === "AInternalTxn",
                      //           ) === undefined
                      //         ? "This transaction requires another user's approval before distribution."
                      //         : null
                      //     : null
                      // }
                      recreate={
                        viewInternalTxnDetails?.[0]?.lifecycle_status ===
                        "rejected"
                      }
                      recreateReason={
                        viewInternalTxnDetails?.[0]?.rejection_reason?.length >
                        RejectReasonLength.lengthOfDecline
                          ? viewInternalTxnDetails?.[0]?.rejection_reason.slice(
                              GlobalConfiguration.lengthCheckZero,
                              RejectReasonLength.lengthOfDecline,
                            ) + "..."
                          : viewInternalTxnDetails?.[0]?.rejection_reason
                      }
                      recreateBtnNeeded={
                        !viewInternalTxnDetails?.[0]?.refactored
                      }
                      handleRecreateBtn={() => {
                        if (hasCreateService) {
                          sessionStorage.setItem(
                            "recreate_int_txn_id",
                            JSON.stringify(viewInternalTxnDetails?.[0]?.txn_id),
                          );
                          navigate("/internal_transaction_dashboard/create", {
                            state: {
                              txn_id: viewInternalTxnDetails?.[0]?.txn_id,
                              type: "refactorFlow",
                            },
                          });
                        } else {
                          navigate("/feature_not_assigned", {
                            state: {
                              unavailableService: ["CInternalTxn"],
                            },
                          });
                        }
                      }}
                      isRecreateDisabled={!hasCreateService}
                      accountApprovalPending={
                        viewInternalTxnDetails?.[0]
                          ?.internal_account_approval_status === "pending" &&
                        viewInternalTxnDetails?.[0]?.lifecycle_status ===
                          "pending"
                      }
                      accountApprovalPendingSubHeader={
                        services?.find(
                          (service) => service === "AInternalTxn",
                        ) !== undefined
                          ? "Account is not approved, approve account before approving transaction."
                          : "To approve the account, please contact the authorized person."
                      }
                      handleApprovalPendingBtn={() => {
                        if (
                          (services?.includes("IVAccount") &&
                            services?.includes("IAAccount")) ||
                          services?.includes("Admin")
                        ) {
                          setInternalAccountDetailpop(true);
                        } else {
                          navigate("/feature_not_assigned", {
                            state: {
                              unavailableService: "IAAccount, IVAccount, Admin",
                            },
                          });
                        }
                      }}
                      isApprovalPendingDisabled={
                        !services?.find((service) => service === "AInternalTxn")
                      }
                      pending={
                        viewInternalTxnDetails?.[0]
                          ?.internal_account_approval_status === "approved" &&
                        viewInternalTxnDetails?.[0]?.lifecycle_status ===
                          "pending"
                      }
                      whichBtnClicked={
                        btnClicked?.[viewInternalTxnDetails?.[0]?.txn_id] ||
                        "none"
                      }
                      rejectMobClick={() => {
                        if (
                          services?.find(
                            (service) => service === "AInternalTxn",
                          ) !== undefined &&
                          checkInternalTransaction
                        ) {
                          setbtnClicked((prev) => ({
                            ...prev,
                            [viewInternalTxnDetails?.[0]?.txn_id]: "Reject",
                          }));
                          handleDeclinedDetails(
                            viewInternalTxnDetails?.[0]?.txn_id,
                          );
                        } else {
                          navigate("/feature_not_assigned", {
                            state: {
                              unavailableService: "AInternalTxn",
                            },
                          });
                        }
                      }}
                      isRejectMobDisable={!checkInternalTransaction}
                      approveMobClick={() => {
                        if (
                          services?.find(
                            (service) => service === "AInternalTxn",
                          ) !== undefined &&
                          checkInternalTransaction
                        ) {
                          setbtnClicked((prev) => ({
                            ...prev,
                            [viewInternalTxnDetails?.[0]?.txn_id]: "Approve",
                          }));
                          handleApproveInternalTransaction(
                            viewInternalTxnDetails?.[0]?.txn_id,
                          );
                        } else {
                          navigate("/feature_not_assigned", {
                            state: {
                              unavailableService: "AInternalTxn",
                            },
                          });
                        }
                      }}
                      isApproveMobDisable={!checkInternalTransaction}
                    />
                  </div>
                </div>
              </div>

              <div className="w-screen  bg-primary-bg block lg:hidden">
                <div className="flex flex-col w-width-full m-auto">
                  <div className="flex flex-col w-width-full mt-margin-md ">
                    <div className="py-padding-sm px-padding-md  text-font-sm text-text-primary text-left font-sans font-semibold bg-primary-card ">
                      Quick Action
                    </div>
                    <div className="w-width-full flex flex-col items-center">
                      <div className="w-width-full flex flex-row">
                        <TopNavLargeButton
                          btnText={
                            <>
                              {" "}
                              Transaction <br /> history
                            </>
                          }
                          handleFunction={() => {
                            if (type === "internal_txn_detail_modal") {
                              actionRestricted();
                            } else {
                              openTransactionHistory();
                              setModalType("Transaction history");
                            }
                          }}
                          icon={transactionHistory}
                          enabledBgColor={"var(--primary-nav-act)"}
                          enabledTextColor={"var(--text-primary)"}
                          hoverOption="white"
                          isDisabled={type === "internal_txn_detail_modal"}
                          fullWidthRequired={true}
                        />
                      </div>
                      {hasConfidential &&
                      internalTxnData?.transaction?.[
                        GlobalConfiguration.lengthCheckZero
                      ]?.confidential_transaction === "Y" ? (
                        <div className="border-t-primary-bg border-t-border w-width-full">
                          <TopNavLargeButton
                            btnText={
                              <>
                                {" "}
                                Confidential <br /> transactions
                              </>
                            }
                            handleFunction={() => {
                              if (type === "internal_txn_detail_modal") {
                                actionRestricted();
                              } else {
                                openTransactionHistory();
                                setModalType("Confidential transaction");
                              }
                            }}
                            icon={confidential_transactionImg}
                            enabledBgColor={"var(--primary-nav-act)"}
                            enabledTextColor={"var(--text-primary)"}
                            hoverOption="white"
                            isDisabled={type === "internal_txn_detail_modal"}
                            fullWidthRequired={true}
                          />
                        </div>
                      ) : (
                        <></>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              className={`Txntimeline ${
                type === "internal_txn_detail_modal"
                  ? "w-width-full"
                  : "w-screen"
              }`}
            >
              <div className="flex-row w-width-full timeline_box max-w-tab-width-normal m-auto flex">
                <div
                  className={`bg-primary-card flex flex-col w-full lg:w-width-md mx-margin-md lg:mx-margin-base h-auto mt-margin-md
  overflow-hidden relative rounded-bl-border-radius-md rounded-t-border-radius-md
  ${
    viewInternalTxnDetails?.[GlobalConfiguration.lengthCheckZero]
      ?.internal_account_approval_status === "approved" &&
    viewInternalTxnDetails?.[GlobalConfiguration.lengthCheckZero]
      ?.lifecycle_status === "approved"
      ? "rounded-br-border-radius-md"
      : viewInternalTxnDetails?.[GlobalConfiguration.lengthCheckZero]
            ?.internal_account_approval_status === "pending" &&
          viewInternalTxnDetails?.[GlobalConfiguration.lengthCheckZero]
            ?.lifecycle_status === "approved"
        ? "rounded-b-border-radius-md"
        : "lg:rounded-br-none rounded-b-border-radius-md"
  }
`}
                >
                  <div
                    className={`flex flex-col w-full h-auto
      ${
        viewInternalTxnDetails?.[GlobalConfiguration.lengthCheckZero]
          ?.internal_account_approval_status === "approved" &&
        viewInternalTxnDetails?.[GlobalConfiguration.lengthCheckZero]
          ?.lifecycle_status === "pending"
          ? "rounded-bl-border-radius-md rounded-br-border-radius-md"
          : "rounded-b-border-radius-md"
      }
      rounded-t-border-radius-md overflow-hidden relative
    `}
                  >
                    <div className="pt-px bg-primary-nav rounded-tl-border-radius-md px-padding-md rounded-tr-border-radius-md">
                      <p className="text-text-primary text-font-xs text-left font-semibold my-margin-sm">
                        Transaction Timeline
                      </p>
                      <div className="border-b border-primary-bg"></div>
                    </div>

                    <div ref={leftContentRef}>
                      <CommonTimeLineCard
                        logsData={viewInternalTxnDetails}
                        handleApprovalClick={handleTimelinePopup}
                        handleDistributionClick={handleDistributionClick}
                        showApprovalTimeline={showApprovalTimeline}
                        showDistributionTimeline={showDistributionTimeline}
                        showDistributionRightIcon={true}
                        showApprovalLeftIcon={true}
                        isDisabled={
                          type === "internal_txn_detail_modal" ? true : false
                        }
                        cardType={"double"}
                      />
                    </div>
                  </div>
                </div>

                <div
                  className={`h-full lg:flex hidden ${
                    viewInternalTxnDetails?.[
                      GlobalConfiguration.lengthCheckZero
                    ]?.internal_account_approval_status === "pending" &&
                    viewInternalTxnDetails?.[
                      GlobalConfiguration.lengthCheckZero
                    ]?.lifecycle_status === "pending"
                      ? "w-width-md"
                      : "w-width-base"
                  }`}
                >
                  <TimelineStatusBar
                    showMobile={false}
                    key={viewInternalTxnDetails?.[0]?.txn_id}
                    overrideAutoLoader
                    isLoading={
                      loadingBox &&
                      viewInternalTxnDetails?.[0]?.lifecycle_status ===
                        "pending"
                    }
                    approvalNotPossible={
                      networkError ||
                      errorMessage ||
                      viewInternalTxnDetails?.[0]?.message
                    }
                    approvalNotPossibleIcon={true}
                    handleApprovalNotPossibleBtn={() => {
                      if (services?.includes("AInternalTxn")) {
                        CommonToast({
                          text: "Feature coming soon",
                          icon: "https://q2pay.in/new_assets/common/detail_page/info.svg",
                          variant: "var(--coming-soon)",
                          buttonNeeded: false,
                        });
                        // setShowRecreatePopup(true);
                      } else {
                        navigate("/feature_not_assigned", {
                          state: {
                            unavailableService: "AInternalTxn",
                          },
                        });
                      }
                    }}
                    isApprovalNotPossibleDisabled={false}
                    furtherApprovalPending={
                      (viewInternalTxnDetails?.[0]?.last_updated_status ===
                        "Approved" &&
                        viewInternalTxnDetails?.[0]?.lifecycle_status ===
                          "pending" &&
                        viewInternalTxnDetails?.[0]?.last_updated_user_id ===
                          loginid?.employees?.id) ||
                      (viewInternalTxnDetails?.[0]?.last_updated_status ===
                        "Approved" &&
                        viewInternalTxnDetails?.[0]?.lifecycle_status ===
                          "pending" &&
                        services?.find(
                          (service) => service === "AInternalTxn",
                        ) === undefined)
                    }
                    // furtherApprovalPendingSubHeader={
                    //   viewInternalTxnDetails?.[0]?.last_updated_status ===
                    //     "Approved" &&
                    //   viewInternalTxnDetails?.[0]?.lifecycle_status ===
                    //     "pending"
                    //     ? viewInternalTxnDetails?.[0]?.last_updated_user_id ===
                    //       loginid?.employees?.id
                    //       ? "This transaction has been approved by you, but it requires another user's approval before settlement."
                    //       : services?.find(
                    //             (service) => service === "AInternalTxn",
                    //           ) === undefined
                    //         ? "This transaction requires another user's approval before settlement."
                    //         : null
                    //     : null
                    // }
                    recreate={
                      viewInternalTxnDetails?.[0]?.lifecycle_status ===
                      "rejected"
                    }
                    recreateReason={
                      viewInternalTxnDetails?.[0]?.rejection_reason?.length >
                      RejectReasonLength.lengthOfDecline
                        ? viewInternalTxnDetails?.[0]?.rejection_reason.slice(
                            GlobalConfiguration.lengthCheckZero,
                            RejectReasonLength.lengthOfDecline,
                          ) + "..."
                        : viewInternalTxnDetails?.[0]?.rejection_reason
                    }
                    recreateBtnNeeded={true}
                    handleRecreateBtn={() => {
                      if (hasCreateService) {
                        sessionStorage.setItem(
                          "recreate_int_txn_id",
                          JSON.stringify(viewInternalTxnDetails?.[0]?.txn_id),
                        );
                        navigate("/internal_transaction_dashboard/create", {
                          state: {
                            txn_id: viewInternalTxnDetails?.[0]?.txn_id,
                            type: "refactorFlow",
                          },
                        });
                      } else {
                        navigate("/feature_not_assigned", {
                          state: {
                            unavailableService: ["CInternalTxn"],
                          },
                        });
                      }
                    }}
                    isRecreateDisabled={!hasCreateService}
                    accountApprovalPending={
                      viewInternalTxnDetails?.[
                        GlobalConfiguration.lengthCheckZero
                      ]?.internal_account_approval_status === "pending" &&
                      viewInternalTxnDetails?.[
                        GlobalConfiguration.lengthCheckZero
                      ]?.lifecycle_status === "pending"
                    }
                    accountApprovalPendingSubHeader={
                      services?.find(
                        (service) => service === "AInternalTxn",
                      ) !== undefined
                        ? "Account is not approved, approve account before approving transaction."
                        : "To approve the account, please contact the authorized person."
                    }
                    handleApprovalPendingBtn={() => {
                      if (
                        (services?.includes("IVAccount") &&
                          services?.includes("IAAccount")) ||
                        services?.includes("Admin")
                      ) {
                        setInternalAccountDetailpop(true);
                      } else {
                        navigate("/feature_not_assigned", {
                          state: {
                            unavailableService: "IAAccount, IVAccount, Admin",
                          },
                        });
                      }
                    }}
                    isApprovalPendingDisabled={
                      !services?.find((service) => service === "AInternalTxn")
                    }
                    pending={
                      viewInternalTxnDetails?.[0]
                        ?.internal_account_approval_status === "approved" &&
                      viewInternalTxnDetails?.[0]?.lifecycle_status ===
                        "pending"
                    }
                    rejectClick={() => {
                      if (
                        services?.find(
                          (service) => service === "AInternalTxn",
                        ) !== undefined &&
                        checkInternalTransaction
                      ) {
                        setbtnClicked((prev) => ({
                          ...prev,
                          [viewInternalTxnDetails?.[0]?.txn_id]: "reject",
                        }));
                        handleDeclinedDetails(
                          viewInternalTxnDetails?.[0]?.txn_id,
                        );
                      } else {
                        navigate("/feature_not_assigned", {
                          state: {
                            unavailableService: "AInternalTxn",
                          },
                        });
                      }
                    }}
                    isRejectDisable={!checkInternalTransaction}
                    approveClick={() => {
                      if (
                        services?.find(
                          (service) => service === "AInternalTxn",
                        ) !== undefined &&
                        checkInternalTransaction
                      ) {
                        setbtnClicked((prev) => ({
                          ...prev,
                          [viewInternalTxnDetails?.[0]?.txn_id]: "Approve",
                        }));
                        handleApproveInternalTransaction(
                          viewInternalTxnDetails?.[0]?.txn_id,
                        );
                      } else {
                        navigate("/feature_not_assigned", {
                          state: {
                            unavailableService: "AInternalTxn",
                          },
                        });
                      }
                    }}
                    isApproveDisable={!checkInternalTransaction}
                    whichBtnClicked={
                      btnClicked?.[viewInternalTxnDetails?.[0]?.txn_id] ||
                      "none"
                    }
                  />
                </div>
              </div>

              <div
                className={`details-div-trans  lg:pt-padding-base mb-margin-md ${
                  type === "internal_txn_detail_modal"
                    ? "w-width-full"
                    : "w-screen"
                }`}
              >
                <div className="detail-section-trans h-auto m-auto max-w-tab-width-normal">
                  <div className="flex pt-padding-md Qsmd:pl-padding-md Qlg:pl-padding-base Qmd:ml-margin-base ml-margin-md mr-margin-md">
                    <div className="flex switch-tab-parent gap-gap-sm bg-primary-card rounded-border-radius-md w-auto Qsm:overflow-x-hidden ">
                      <SwitcherTabs
                        initialActiveTab={
                          type === "internal_txn_detail_modal"
                            ? "additional_details"
                            : "details"
                        }
                        tabs={[
                          {
                            label: "Details",
                            handler: toggleDetails,
                            key: "details",
                          },
                          {
                            label: "Additional details",
                            handler: toggleAdditionalDetails,
                            key: "additional_details",
                          },
                          {
                            label: "Labels",
                            handler: toggleLabels,
                            key: "assigned labels",
                          },
                        ]}
                        setIndex={setIndex}
                      />
                    </div>
                  </div>
                  {index === GlobalConfiguration?.lengthCheckZero && (
                    <div className={animationClass}>
                      {viewInternalTxnDetails?.map((account) => {
                        /**
                         * @type {import("../../../components/_utils/CommonDetailCard/index.jsx").Entry[]}
                         */
                        let originItemList = [
                          {
                            content:
                              (account?.logs?.[
                                GlobalConfiguration.lengthCheckZero
                              ]?.first_name ?? "") +
                              " " +
                              (account?.logs?.[
                                GlobalConfiguration.lengthCheckZero
                              ]?.last_name
                                ? account.logs[
                                    GlobalConfiguration.lengthCheckZero
                                  ].last_name[
                                    GlobalConfiguration.lengthCheckZero
                                  ]?.toUpperCase() +
                                  account.logs[
                                    GlobalConfiguration.lengthCheckZero
                                  ].last_name.slice(
                                    GlobalConfiguration.lengthCheckOne,
                                  )
                                : ""),
                            heading: "Created by",
                            type: "text",
                          },
                          {
                            content: formatDateViewAll(account?.created_on),
                            heading: "Created on",
                            type: "text",
                          },
                        ];

                        /**
                         * @type {import("../../../components/_utils/CommonDetailCard/index.jsx").Entry[]}
                         */
                        let settlementItemList = [];
                        if (
                          account?.distribution_lifecycle_status ===
                          "distribution_complete"
                        ) {
                          settlementItemList = [
                            {
                              content: account?.distribution_credited_at
                                ? ISO_DataFormatter(
                                    account?.distribution_credited_at,
                                  )
                                : "N/A",
                              heading: "Settled on",
                              type: "text",
                            },
                            {
                              content: account?.distribution_settlement_id
                                ? account?.distribution_settlement_id
                                : "N/A",
                              heading: "Settlement ID",
                              type: "text",
                            },
                          ];
                        }

                        /**
                         * @type {import("../../../components/_utils/CommonDetailCard/index.jsx").Entry[]}
                         */
                        let supportItemList = [
                          {
                            content: account.txn_id,
                            heading: "Transaction ID",
                            type: "text",
                          },
                          ...(account?.distribution_identifier
                            ? [
                                {
                                  content: account.distribution_identifier,
                                  heading: "Distribution identifier",
                                  type: "text",
                                },
                              ]
                            : []),
                        ];

                        return (
                          <div
                            className={`flex flex-col lg:flex-row my-margin-md px-padding-md lg:px-padding-base ${
                              account?.distribution_lifecycle_status ===
                              "distribution_complete"
                                ? "justify-between gap-gap-md"
                                : "gap-gap-md"
                            }`}
                          >
                            <CommonDetailCard
                              cardTitle="Origin Details"
                              numCols={GlobalConfiguration?.lengthCheckOne}
                              variant="third"
                              entries={originItemList}
                            />

                            {account?.distribution_lifecycle_status ===
                              "distribution_complete" && (
                              <CommonDetailCard
                                cardTitle="Settlement Details"
                                numCols={GlobalConfiguration?.lengthCheckOne}
                                variant="third"
                                entries={settlementItemList}
                              />
                            )}

                            <CommonDetailCard
                              cardTitle="Support Information"
                              numCols={GlobalConfiguration?.lengthCheckOne}
                              variant="third"
                              entries={supportItemList}
                            />
                          </div>
                        );
                      })}
                    </div>
                  )}

                  {index === GlobalConfiguration?.lengthCheckOne && (
                    <div className={animationClass}>
                      <div className="flex flex-col lg:flex-row items-center Qmd:items-start gap-gap-md pb-padding-md text-text-primary mt-margin-md px-padding-md lg:px-padding-base">
                        <>
                          {validItems?.filter(
                            (item) =>
                              item.name !== "Hyperlink" &&
                              item.name !== "File" &&
                              item.name !== "Image",
                          ).length === GlobalConfiguration?.lengthCheckZero ? (
                            <div className="Qlg:w-details-card-lg w-width-full flex flex-row Qlg:flex-col p-padding-md gap-gap-md bg-primary-card rounded-border-radius-md">
                              <div className="text-text-primary text-font-sm font-semibold">
                                Additional Details
                              </div>
                              <p className="text-text-secondary text-font-xs font-normal">
                                Additional details are not supported for the
                                selected category.
                              </p>
                            </div>
                          ) : (
                            <>
                              {(() => {
                                const filteredItems = validItems.filter(
                                  (item) =>
                                    item.name !== "Hyperlink" &&
                                    item.name !== "File" &&
                                    item.name !== "Image",
                                );

                                const midIndex = Math.ceil(
                                  filteredItems.length /
                                    GlobalConfiguration?.lengthCheckTwo,
                                );
                                const leftColumn = filteredItems.slice(
                                  GlobalConfiguration?.lengthCheckZero,
                                  midIndex,
                                );
                                const rightColumn =
                                  filteredItems.slice(midIndex);

                                const orderedItems = [];
                                for (
                                  let i = GlobalConfiguration?.lengthCheckZero;
                                  i < midIndex;
                                  i++
                                ) {
                                  if (leftColumn[i])
                                    orderedItems.push(leftColumn[i]);
                                  if (rightColumn[i])
                                    orderedItems.push(rightColumn[i]);
                                }

                                return (
                                  <CommonDetailCard
                                    cardTitle="Additional details"
                                    numCols={
                                      GlobalConfiguration?.lengthCheckTwo
                                    }
                                    variant="third"
                                    entries={orderedItems.map((subItem) => {
                                      switch (subItem.data_type) {
                                        case "toggle":
                                          return {
                                            content: subItem?.value
                                              ? "Yes"
                                              : "No",
                                            heading: subItem?.name,
                                            type: "text",
                                          };
                                        case "multi_select_list":
                                          return {
                                            content:
                                              Array.isArray(subItem?.value) &&
                                              subItem?.value?.length >
                                                GlobalConfiguration?.lengthCheckZero
                                                ? subItem.value.join(", ")
                                                : "Not Given",
                                            heading: subItem?.name,
                                            type: "text",
                                          };
                                        case "date_range":
                                          return {
                                            content: subItem?.value?.start_date
                                              ? `${subItem.value.start_date} - ${subItem.value.end_date}`
                                              : "Not Given",
                                            heading: "From date - To date",
                                            type: "text",
                                          };
                                        case "from_year_to_year":
                                          return {
                                            content: subItem?.value?.from
                                              ? `${subItem.value.from} - ${subItem.value.to}`
                                              : "Not Given",
                                            heading: "From year - To year",
                                            type: "text",
                                          };
                                        default:
                                          return {
                                            content:
                                              subItem?.value ?? "Not Given",
                                            heading: subItem?.name,
                                            type: "text",
                                          };
                                      }
                                    })}
                                  />
                                );
                              })()}
                            </>
                          )}
                        </>

                        {attachments.length >
                          GlobalConfiguration?.lengthCheckZero && (
                          <>
                            <CommonDetailCard
                              cardTitle="Attachments"
                              numCols={GlobalConfiguration.lengthCheckOne}
                              variant="third"
                              entries={attachments.map((obj, index) => {
                                switch (obj.name) {
                                  case "Hyperlink":
                                    return {
                                      content: obj?.value ?? "#",
                                      heading: "URL",
                                      type: "link",
                                    };
                                  default: {
                                    let ob = obj.value;
                                    const mt =
                                      ob?.metadata?.mime_type ??
                                      "application/octet-stream";
                                    switch (mt.toUpperCase()) {
                                      case "IMAGE/PNG":
                                      case "IMAGE/JPEG":
                                      case "IMAGE/JPG":
                                        return {
                                          content: {
                                            fileName: ob?.metadata?.filename,
                                            size: ob?.metadata?.size ?? "0",
                                            mimeType: mt,
                                            url: ob?.file_url,
                                          },
                                          heading: "Image",
                                          type: "image",
                                        };
                                      default:
                                        return {
                                          content: {
                                            fileName: ob?.metadata?.filename,
                                            size: ob?.metadata?.size ?? "0",
                                            mimeType: mt,
                                            url: ob?.file_url,
                                          },
                                          heading: "File",
                                          type: "file",
                                        };
                                    }
                                  }
                                }
                              })}
                            />
                          </>
                        )}
                      </div>
                    </div>
                  )}

                  {index === GlobalConfiguration?.lengthCheckTwo && (
                    <div className={animationClass}>
                      <div className="mt-margin-md">
                        <CommonContainerCard
                          header="Assigned Labels"
                          subheader={TEXT?.LABELS_STATS_USAGE_NOTE}
                          iconIsDisabled={type === "internal_txn_detail_modal"}
                          icon={
                            "https://q2pay.in/new_assets/common/create_flow/edit.svg"
                          }
                          handleFunction={(e) => {
                            e.stopPropagation();

                            if (
                              !(
                                services?.includes("ALabel") &&
                                services?.includes("RLabel")
                              )
                            ) {
                              navigate("/feature_not_assigned", {
                                state: {
                                  unavailableService: "ALabel,RLabel",
                                },
                              });
                              return;
                            }

                            if (type === "internal_txn_detail_modal") {
                              actionRestricted();
                              return;
                            }

                            setShowLabelsPopup(true);
                          }}
                        >
                          <div className="flex flex-wrap w-width-full gap-gap-sm overflow-x-auto">
                            {Array.isArray(labelDetails) &&
                            labelDetails.length ? (
                              <>
                                {labelDetails?.map((item, index) => (
                                  <Chips
                                    key={index}
                                    txtChip={item}
                                    enabledBgColor="var(--primary-nav)"
                                    disableIcon={true}
                                    handleFunction={(e) => {
                                      e.stopPropagation();
                                      return;
                                    }}
                                    enabledTextColor="var(--text-primary)"
                                  />
                                ))}
                              </>
                            ) : (
                              <p className="text-font-sm text-text-primary">
                                No labels assigned.
                              </p>
                            )}
                          </div>
                        </CommonContainerCard>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default InternalTransactionDetails;
